import React, { useState, useEffect } from 'react';
import { getPublicQuizzes } from '../../firebase';
import logger from '../../utils/logger';
import './PublicQuizList.css';

function PublicQuizList({ onSelectQuiz }) {
  const [publicQuizzes, setPublicQuizzes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPublicQuizzes = async () => {
      try {
        logger.info('Fetching public quizzes', {}, 'COMPONENT');
        setLoading(true);
        const quizzes = await getPublicQuizzes();
        setPublicQuizzes(quizzes);
        logger.info('Successfully fetched public quizzes', { count: quizzes.length }, 'COMPONENT');
        setError(null);
      } catch (error) {
        logger.error('Failed to fetch public quizzes', { error: error.message }, 'COMPONENT');
        setError('公開クイズの読み込みに失敗しました');
      } finally {
        setLoading(false);
      }
    };

    fetchPublicQuizzes();
  }, []);

  const handleSelectQuiz = (quiz) => {
    logger.userAction('select_public_quiz', { 
      quizId: quiz.id, 
      userId: quiz.userId,
      title: quiz.title 
    });
    // 共有URLに直接リンクする
    const sharedUrl = `/shared-quiz/${quiz.userId}/${quiz.id}`;
    window.location.href = sharedUrl;
  };

  if (loading) {
    return (
      <div className="public-quiz-list">
        <div className="loading-spinner">公開クイズを読み込み中...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="public-quiz-list">
        <div className="error-message">{error}</div>
      </div>
    );
  }

  return (
    <div className="public-quiz-list">
      <div className="quiz-list-header">
        <div className="list-info">
          <h2>公開クイズ一覧</h2>
          <div className="quiz-tabs">
            <button 
              onClick={() => window.location.href = '/?tab=login'} 
              className="tab-btn login-btn"
            >
              ログイン
            </button>
            <button 
              onClick={() => window.location.href = '/?tab=signup'} 
              className="tab-btn signup-btn"
            >
              アカウント作成
            </button>
          </div>
          <p className="list-info-details">
            他のユーザーが公開しているクイズに挑戦できます
          </p>
        </div>
      </div>

      {publicQuizzes.length === 0 ? (
        <div className="no-quizzes">
          <p>公開されているクイズがありません</p>
        </div>
      ) : (
        <div className="quiz-grid">
          {publicQuizzes.map((quiz) => (
            <div key={`${quiz.userId}-${quiz.id}`} className="quiz-card">
              <div className="quiz-card-header">
                <h3>{quiz.title}</h3>
              </div>
              <p className="quiz-description">{quiz.description}</p>
              <div className="quiz-metadata">
                <p className="quiz-date">
                  作成日: {new Date(quiz.createdAt).toLocaleDateString('ja-JP')}
                </p>
                <p className="quiz-author">
                  作成者: {quiz.displayName}
                </p>
              </div>
              <div className="quiz-actions">
                <button 
                  className="quiz-start-btn"
                  onClick={() => handleSelectQuiz(quiz)}
                >
                  クイズを開始
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default PublicQuizList;